import { BrowserRouter } from 'react-router-dom';

import Menubar from './Menubar';
import Router from './Router';

import styles from './App.module.css';
import { useState } from 'react';

function App() {

    const [displayMenu, setDisplayMenu] = useState(true);

    return (
        <div className='App'>
            <BrowserRouter>
                <div style={{width: '100%', minHeight: '100vh', display: 'flex'}}>
                    <div style={{display: displayMenu ? 'none' : 'block'}} className={styles.openButton} onClick={() => setDisplayMenu(true)}>메뉴</div>
                    <div style={{display: displayMenu ? 'block' : 'none'}} className={styles.bar}>
                        <Menubar />
                        <div className={styles.closeButton} onClick={() => setDisplayMenu(false)}>X</div>
                    </div>
                    <div className={styles.router}>
                        <Router />
                    </div>
                </div>
            </BrowserRouter>
        </div>
    );
}

export default App;